export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9')
];

export const server_loads = [];

export const dictionary = {
		"/": [3],
		"/[lang]": [~4,[2]],
		"/[lang]/about": [~5,[2]],
		"/[lang]/artists": [~6,[2]],
		"/[lang]/artists/[artist]": [~7,[2]],
		"/[lang]/request": [~8,[2]],
		"/[lang]/request/thanks": [9,[2]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
};

export { default as root } from '../root.svelte';